module.exports = __webpack_public_path__ + "static/media/connexBg.0150669c.png";